const EMAIL_VERIFICATION = {
    REQUEST: 'EMAIL_VERIFICATION_REQUEST',
    SUCCESS: 'EMAIL_VERIFICATION_SUCCESS',
    ERROR: 'EMAIL_VERIFICATION_ERROR',
    RESET: 'EMAIL_VERIFICATION_RESET'
}

export {EMAIL_VERIFICATION}